import { Box } from "@mui/material";
import AppBar from "components/app-bar";
import Game from "components/game";

function App() {
  return (
    <Box height="100vh">
      <AppBar />
      <Game />
    </Box>
  );
}

export default App;
